import request from "@/axios/index";

// 获取一次返回主表, 子表, 子子表全部数据
export function dynamicDetailData(params) {
  return request({
    url: "/custom/selectDetailAll",
    method: "get",
    params
  })
}
// 返回单据结构（入参和page接口一致）
export function dynamicDetailConfig(params) {
  return request({
    url: "/custom/page/detail",
    method: "get",
    params
  })
}
// 远程选择框数据
export function getRemoteCondition(id, params) {
  return request({
    url: `/dataItem/by/condition/${id}`,
    method: "get",
    params
  })
}
///sys/user/pageUserList
export function getUserList(params) {
  return request({
    url: "/sys/user/pageUserList",
    method: "get",
    params
  })
}
// 获取打印模板列表
export function getReportList(params) {
  return request({
    url: "/sys/report",
    method: "get",
    params
  })
}
// 下载打印模板
export function downloadReport(data) {
  return request({
    url: "/sys/report/download",
    method: "post",
    responseType: "blob",
    data
  })
}
// 删除单据
export function deleteDynamicDetail(params, data) {
  return request({
    url: "/custom/deleteDetail",
    method: "post",
    params,
    data
  })
}
// 保存打印
export function gxupdateData(params, data) {
  return request({
    url: "/custom/updateAll",
    method: "post",
    params,
    data
  })
}

// 子表数据导入接口
export function importExcel(data) {
  return request({
    url: "/custom/importExcel?importType='ADD'",
    method: "post",
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}

// 调取数据
export function getSelectFetchList(params, data) {
  return request({
    url: "/custom/selectFetchList",
    method: "post",
    params,
    data
  })
}
// /activiti/findLastAssignee
export function getFindLastAssignee(params) {
  return request({
    url: "/activiti/findLastAssignee",
    method: "get",
    params
  })
}
// /common/association/page
export function getAssociationPage(params) {
  return request({
    url: "/common/association/page",
    method: "get",
    params
  })
}
// /common/upload
export function uploadAnnexFile(data) {
  return request({
    url: "/common/upload",
    method: "post",
    data
  })
}
// 附件下载
export function downloadAnnexFile(id) {
  return request({
    url: `/common/download/${id}`,
    method: "get",
    responseType: 'blob'
  })
}
// 附件删除
export function deleteAnnexFile(id) {
  return request({
    url: `/common/association/${id}`,
    method: "delete"
  })
}
// 获取OCR识别的内容
export function getOcrContent(params) {
  return request({
    url: "/file-api/getContent",
    method: "get",
    params
  })
}
// /productCategory/tree_select
export function getProductCategoryTreeSelect(params) {
  return request({
    url: "/productCategory/tree_select",
    method: "get",
    params
  })
}
// 调取 /fetch
export function dynamicFetchConfig(params) {
  return request({
    url: "/custom/page/fetch",
    method: "get",
    params
  })
}
// /file-api/getMapperRecordList
export function getDynamicMapperRecordList(params) {
  return request({
    url: "/file-api/getMapperRecordList",
    method: "get",
    params
  })
}

// 附件管理模块
export function getAttachmentList(data) {
  return request({
    url: "/common/association/imputation",
    method: "POST",
    data
  })
}
// /file-api/addMapperRecord
export function addMapperRecord(data) {
  return request({
    url: "/file-api/addMapperRecord",
    method: "POST",
    data
  })
}
// 传单一窗口
export function updateDecStatus(params, data) {
  return request({
    url: "/custom/updateDecStatus",
    method: "POST",
    params,
    data
  })
}